/**
* @public
*/
const PlaybackStates = {
	NOTREADY			: 'NOTREADY',
	PAUSED				: 'PAUSED',
	BUFFERING			: 'BUFFERING',
	PLAYING 			: 'PLAYING',
	SEEKING				: 'SEEKING',
	ENDED 				: 'ENDED',
};

export default PlaybackStates;



// WEBPACK FOOTER //
// ./src/PlaybackStates.js